import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, CircleX, Clock3 } from 'lucide-react';

const PaymentComplete = () => {
  const [searchParams] = useSearchParams();
  const status = (searchParams.get('status') || 'PENDING').toUpperCase();
  const bookingId = searchParams.get('bookingId');
  const message = searchParams.get('message');

  const content = (() => {
    if (status === 'SUCCESS') {
      return {
        icon: <CheckCircle2 className="w-16 h-16 text-green-600" />,
        title: 'Payment Completed',
        description: message || 'Your booking payment has been received successfully.'
      };
    }

    if (status === 'FAILED') {
      return {
        icon: <CircleX className="w-16 h-16 text-red-600" />,
        title: 'Payment Failed',
        description: message || 'We could not confirm your payment. You can retry from your bookings page.'
      };
    }

    return {
      icon: <Clock3 className="w-16 h-16 text-amber-500" />,
      title: 'Payment Pending',
      description: message || 'Your payment is still being processed. Please check your bookings shortly.'
    };
  })();

  return (
    <div className="min-h-screen bg-white px-6 py-16 sm:px-8">
      <div className="mx-auto max-w-2xl rounded-3xl border border-gray-200 bg-white p-8 text-center shadow-sm sm:p-12">
        <div className="mb-6 flex justify-center">{content.icon}</div>
        <p className="mb-3 text-xs font-black uppercase tracking-[0.35em] text-gray-400">Go Rides Payment</p>
        <h1 className="text-3xl font-black uppercase tracking-tight text-black sm:text-4xl">{content.title}</h1>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-gray-600 sm:text-base">{content.description}</p>

        {bookingId && (
          <div className="mt-6 rounded-2xl bg-gray-50 px-5 py-4 text-sm font-semibold text-gray-700">
            Booking Reference: <span className="text-black">{bookingId.slice(0, 8).toUpperCase()}</span>
          </div>
        )}

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Link
            to="/bookings"
            className="rounded-2xl bg-black px-6 py-3 text-sm font-black uppercase tracking-[0.25em] text-white transition hover:bg-gray-800"
          >
            Go To My Bookings
          </Link>
          <Link to="/driver-trips" className="rounded-2xl border border-gray-200 px-6 py-3 text-sm font-bold">Go To Driver Trips</Link>
          <Link
            to="/browse"
            className="rounded-2xl border border-gray-200 px-6 py-3 text-sm font-black uppercase tracking-[0.25em] text-black transition hover:border-black"
          >
            Browse Cars
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentComplete;
